import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProcess, clearProcess, fetchProcessFilters} from 'app/actions/ProcessActions';
import { getProcess, getIsLoadingProcess, getProcessFilters } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';


export default function ProcessTableContainer(props) {
    const {idSubdirection} = useSelector(state => state.Auth.employeeById);
    const { classes } = props;
    const { confirm } = Modal;
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Nombre del proceso',
            dataIndex: 'processName',
            key: 0,
            sorter: true,
            editable: true,
        },
        {
            title: 'Codigo de procedimiento',
            dataIndex: 'courseCode',
            key: 1,
            sorter: true,
            ellipsis: true

        },
        {
            title: 'Nombre del procedimiento',
            dataIndex: 'courseName',
            key: 2,
            sorter: true,
        },
        
    ];

    const showDrawer= (data) => {
        props.setPDFData(data)
        props.setVisiblePDF(true)
    }

    let processData = useSelector(getProcess);
    let processFilters = useSelector(getProcessFilters);

    let isLoading = useSelector(getIsLoadingProcess);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(processFilters)) fetchProcessFiltersAction();
    },[]);


    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchProcess(
            {
                // CommunicationProgram: (typeof props.formData.CommunicationProgram === "undefined") ? '' : props.formData.CommunicationProgram,
                Front: (typeof props.formData.Front === "undefined") ? '' : props.formData.Front,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }, props.formData.idCommunicationProgram));
    };

    
    //Load
        if (pagination != null) {
            offset = (0 * pagination.pageSize);
            limit = (pagination.pageSize);
    
            if (!isLoading && processData.length > 0) {
                pagination.total = processData[0].totalcount;
            }
            else {
                pagination.total = 0;
            }
        }
    
        if (sorter !== null && !props.isFilters) {
            column = sorter.field === undefined ? '': sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
    const fetchProcessFiltersAction = () => dispatch(fetchProcessFilters({idSubdirection:idSubdirection}))
    processData.forEach(i=> i.processName==='' || i.processName===null ? i.processName='-': i.processName);
    return (props.children({ pagination: pagination, cols: columns, processData ,processFilters, isLoading, handleTableChange: handleTableChange }));
}


